import { Pipe, PipeTransform } from "@angular/core";
import { TradableListService } from "@main-services/currency/tradable_list.service";
import { Tradable } from "@models/interfaces/tradable";

@Pipe({
	name: "tradable",
	standalone: false
})
export class TradablePipe implements PipeTransform {
	public constructor(private tradableListService: TradableListService) {}

	public transform(value: string): Tradable {
		return this.tradableListService.getItemById(value);
	}
}

@Pipe({
	name: "tradable_by_pid",
	standalone: false
})
export class TradableByPidPipe implements PipeTransform {
	public constructor(private tradableListService: TradableListService) {}

	public transform(value: string): Tradable {
		return this.tradableListService.getItemByPid(value);
	}
}
